import {
  CheckmarkFilled,
  FlagFilled,
  WarningFilled
} from '@carbon/icons-react';

import {
  AlertWrapper,
  Content,
  Header,
  LabelWrapper,
  StyledBadge
} from 'components/statusPage/StatusPageAlert.styles';
import { Incident } from 'components/statusPage/types';
import { getBadgeVariantForStatusPage } from 'components/statusPage/utils';

export function StatusPageAlert({
  incident
}: {
  incident: Incident;
}): JSX.Element {
  const { displayStatus, name, componentName, shortlink, latestUpdate } =
    incident;

  let icon = <WarningFilled size={20} />;
  if (['critical', 'major', 'minor'].includes(displayStatus)) {
    icon = <FlagFilled size={20} />;
  }
  if (displayStatus === 'resolved') {
    icon = <CheckmarkFilled size={20} />;
  }

  return (
    <AlertWrapper
      data-variant={displayStatus}
      onClick={(event) => {
        if (event.target instanceof HTMLAnchorElement) {
          return;
        }
        window.open(shortlink, '_blank', 'noopener noreferrer');
      }}
    >
      <Header>
        <LabelWrapper>
          {icon}
          <span>{name}</span>
        </LabelWrapper>
        <StyledBadge
          data-variant={getBadgeVariantForStatusPage(displayStatus)}
          data-size="small"
        >
          {componentName}
        </StyledBadge>
      </Header>
      <Content>
        <div
          style={{ whiteSpace: 'pre-line' }}
          dangerouslySetInnerHTML={{
            __html: latestUpdate.body
          }}
        />
      </Content>
    </AlertWrapper>
  );
}
